import React from 'react'
import { useAppSelector, selectAuthStep } from '../store/store'
import { AuthStep } from '../types.d'

import Start from './Start'

import SigninMethodSelector from './signin/MethodSelector'
import SigninEmailOTP from './signin/SigninEmailOTP'
import SigninPasskey from './signin/SigninPasskey'
import SigninPasskeyRetry from './signin/SigninPasskeyRetry'
import SigninPassword from './signin/SigninPassword'
import SigninUnavailable from './signin/SigninUnavailable'

import SigninCreatePasskeyPrompt from './create_passkey/CreatePasskeyPrompt'
import SigninCreatePasskeyLoading from './create_passkey/CreatePasskeyLoading'
import SigninCreatePasskeySuccess from './create_passkey/CreatePasskeySuccess'
import SigninCreatePasskeyError from './create_passkey/CreatePasskeyError'
import SigninCreatePasskeyErrorTerminal from './create_passkey/CreatePasskeyErrorTerminal'

import SignupEmailPrompt from './signup/SignupEmailPrompt'
import SignupNamePrompt from './signup/SignupNamePrompt'
import SignupConfirm from './signup/SignupConfirm'

const stepComponentMap: Record<AuthStep, React.ComponentType> = {
  [AuthStep.START]: Start,

  [AuthStep.SIGNIN_METHOD_SELECTOR]: SigninMethodSelector,
  [AuthStep.SIGNIN_METHOD_EMAILOTP]: SigninEmailOTP,
  [AuthStep.SIGNIN_METHOD_PASSKEY]: SigninPasskey,
  [AuthStep.SIGNIN_METHOD_PASSKEY_RETRY]: SigninPasskeyRetry,
  [AuthStep.SIGNIN_METHOD_PASSWORD]: SigninPassword,
  [AuthStep.SIGNIN_METHOD_UNAVAILABLE]: SigninUnavailable, // Reusing the method selector for unavailable state

  [AuthStep.SIGNIN_CREATE_PASSKEY_PROMPT]: SigninCreatePasskeyPrompt,
  [AuthStep.SIGNIN_CREATE_PASSKEY_LOADING]: SigninCreatePasskeyLoading,
  [AuthStep.SIGNIN_CREATE_PASSKEY_SUCCESS]: SigninCreatePasskeySuccess,
  [AuthStep.SIGNIN_CREATE_PASSKEY_ERROR]: SigninCreatePasskeyError,
  [AuthStep.SIGNIN_CREATE_PASSKEY_ERROR_TERMINAL]:
    SigninCreatePasskeyErrorTerminal,

  [AuthStep.SIGNUP_EMAIL_PROMPT]: SignupEmailPrompt,
  [AuthStep.SIGNUP_NAME_PROMPT]: SignupNamePrompt,
  [AuthStep.SIGNUP_CONFIRM]: SignupConfirm,
}

export const AuthenticationStep = () => {
  const step = useAppSelector(selectAuthStep)
  const Component = stepComponentMap[step]
  return <Component />
}
